import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NumberFormat from 'react-number-format';
import Moment from 'react-moment';
import 'moment/locale/es-mx';
import styles from './styles.module.scss';

import LinkLang from '../../Wraps/LinkLang';
import { startGetCart } from '../../../redux/actions/cartActions';
import apiSuccess from '../../../api/Success';
import ApiOrder from '../../../api/Order/OrderApiFL';
import ApiProduct from '../../../api/Product';

import { ReactComponent as Download } from '../../../assets/icons/icon-download.svg';
import { ReactComponent as Print } from '../../../assets/icons/icon-print.svg';

import Config, { spanish } from '../../../config/config';

const Header = ({ content, userEmail }) => (
  <div className={styles.header}>
    <img
      src={
        Config.cdn.cdn_path +
        (spanish ? content?.imageSpanish?.url : content?.imageEnglish?.url)
      }
      alt="success"
    />
    <p>
      {spanish
        ? content?.TextBeforeEmailSpanish
        : content?.TextBeforeEmailEnglish}{' '}
      <span>{userEmail}</span>{' '}
      {spanish
        ? content?.TextAfterEmailSpanish
        : content?.TextAfterEmailEnglish}
    </p>
  </div>
);

const Info = ({
  successBilling,
  orderInfoHeader,
  orderInfoDetail,
  shippingInfo,
}) => {
  const dateToFormat = orderInfoHeader?.FechaModificacion;
  let envio = '';
  switch (orderInfoHeader?.TipoEnvio) {
    case '2':
      envio = 'DHL - Urgente';
      break;
    case '3':
      envio = 'Dostavista - Mismo día';
      break;
    case '4':
      envio = 'Uber - Mismo día';
      break;
    default:
      envio = '';
      break;
  }
  let counter = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < orderInfoDetail?.length; i++) {
    counter = orderInfoDetail[i]?.Cantidad + counter;
  }

  return (
    <div className={styles.info}>
      <div className={styles.infoContent}>
        <div className={styles.infoBlock}>
          <h5>{spanish ? 'CONFIRMACÓN DE PEDIDO' : 'ORDER CONFIRMATION'}</h5>
          <b>
            {spanish ? 'Pedido' : 'Order'}#:{' '}
            {`MX${orderInfoHeader?.FolioRetail}`}
          </b>
          <b>
            {spanish ? 'Código de facturación:' : 'Billing code:'}{' '}
            {orderInfoHeader?.idPedido}
          </b>
          <p>
            {spanish ? 'Fecha:' : 'Date:'}{' '}
            <Moment
              format="DD MMMM YYYY"
              date={dateToFormat}
              locale={spanish ? 'es-mx' : ''}
            />
          </p>
          <p>
            {spanish ? 'Cantidad:' : 'Quantity:'} {counter}
          </p>
        </div>
        <div className={styles.infoBlock}>
          <h5>{spanish ? 'FECHA DE ENTREGA' : 'DELIVERY DATE'}</h5>
          <b>
            {spanish
              ? 'Pronto recibirás actualizaciones'
              : 'You will recieve updates soon'}
          </b>
          <p>{spanish ? 'Método de envío:' : 'Delivery method:'}</p>
          <p>{envio}</p>
        </div>
        <div className={styles.infoBlock}>
          <h5>{spanish ? 'DIRECCIÓN DE ENTREGA' : 'SHIPPING ADDRESS'}</h5>
          <b>
            {`${shippingInfo?.shippingName} ${
              shippingInfo?.shippingSecondName
                ? shippingInfo?.shippingSecondName
                : ''
            } ${shippingInfo?.shippingLastName}`}
          </b>
          <p>{`${shippingInfo?.shippingAddressLine1}, ${shippingInfo?.shippingAddressLine2}, ${shippingInfo?.shippingSuburb}, ${shippingInfo?.shippingCity}, ${shippingInfo?.shippingState}, ${shippingInfo?.shippingZipCode}, México`}</p>
        </div>
      </div>
      <div className={styles.download}>
        {successBilling && (
          <a href="/">
            <Download />
            <span>{spanish ? 'descargar factura' : 'download invoice'}</span>
          </a>
        )}
        {successBilling && (
          <p>
            {spanish
              ? 'Te recordamos que tienes 48 horas para solicitar tu factura a partir del momento de tu compra'
              : 'We remind you that you have 48 hours to request your invoice from the moment of your purchase'}
          </p>
        )}
      </div>
    </div>
  );
};

const Item = ({ itemDetail }) => {
  const getSKU = itemDetail?.idProducto?.toString();
  const [itemCMS, setItemCMS] = useState(null);
  useEffect(async () => {
    setItemCMS(await ApiProduct.getSKU(getSKU));
  }, []);
  return (
    <div className={styles.item}>
      <div className={styles.itemProduct}>
        <h5>{spanish ? 'resumen' : 'summary'}</h5>
        {itemCMS !== null && (
          <img
            src={
              Config.cdn.cdn_path +
              itemCMS[0]?.imageCatalog?.formats?.thumbnail?.url
            }
            alt={itemCMS[0]?.Name}
          />
        )}
        <div>
          {itemCMS !== null && <b>{itemCMS[0]?.Name}</b>}
          <p>
            {spanish ? 'Producto' : 'Product'}# {itemDetail.idProducto}
          </p>
        </div>
      </div>
      <div className={styles.itemSpecs}>
        <div>
          <h5>{spanish ? 'precio unitario' : 'unit price'}</h5>
          <b>
            <NumberFormat
              value={itemDetail?.PrecioUnitario?.toFixed(2)}
              thousandSeparator
              prefix="$"
              suffix=" MXN"
              displayType="text"
            />
          </b>
        </div>
        <div>
          <h5>{spanish ? 'cantidad' : 'quantity'}</h5>
          <p>{itemDetail?.Cantidad}</p>
        </div>
      </div>
      <div className={styles.itemTotal}>
        <h5>Total:</h5>
        <b>
          <NumberFormat
            value={itemDetail?.PrecioTotal?.toFixed(2)}
            thousandSeparator
            prefix="$"
            suffix=" MXN"
            displayType="text"
          />
        </b>
      </div>
    </div>
  );
};

const Summary = ({ orderDetails }) => {
  const items = orderDetails?.map((item, key) => (
    <Item itemDetail={item} key={key} />
  ));
  return <div className={styles.summary}>{items}</div>;
};

const Breakdown = ({ orderBreakdownInfo }) => (
  <div className={styles.breakdown}>
    <div>
      <p>Subtotal:</p>
      <b>
        <NumberFormat
          value={orderBreakdownInfo?.Subtotal?.toFixed(2)}
          thousandSeparator
          prefix="$"
          suffix=" MXN"
          displayType="text"
        />
      </b>
    </div>
    <div>
      <p>{spanish ? 'Impuestos:' : 'Taxes:'}</p>
      <b>
        <NumberFormat
          value={orderBreakdownInfo?.Impuesto?.toFixed(2)}
          thousandSeparator
          prefix="$"
          suffix=" MXN"
          displayType="text"
        />
      </b>
    </div>
    <div>
      <p>{spanish ? 'Envío:' : 'Shipping:'}</p>
      <b>
        <NumberFormat
          value={orderBreakdownInfo?.CostoEnvio?.toFixed(2)}
          thousandSeparator
          prefix="$"
          suffix=" MXN"
          displayType="text"
        />
      </b>
    </div>
  </div>
);

const GrandTotal = ({ grandTotal }) => (
  <div className={styles.grandTotal}>
    <div>
      <p>{spanish ? 'Total del pedido:' : 'Grand Total:'}</p>
      <b>
        <NumberFormat
          value={grandTotal}
          thousandSeparator
          prefix="$"
          suffix=" MXN"
          displayType="text"
        />
      </b>
    </div>
  </div>
);

const Bottom = ({ content }) => (
  <div className={styles.bottom}>
    <div className={styles.print}>
      <button type="button" onClick={() => window.print()}>
        <span>{spanish ? 'imprimir pantalla' : 'print screen'}</span>
        <Print />
      </button>
    </div>
    <div className={styles.button}>
      <LinkLang to="/" className="btn btn-white">
        {spanish ? content?.BackButtonSpanish : content?.BackButtonEnglish}
      </LinkLang>
    </div>
  </div>
);

const Success = () => {
  const [content, setContent] = useState(false);
  const [orderInfo, setOrderInfo] = useState(null);
  const orderId = useSelector((globalState) => globalState.orderInfo.orderId);
  const shippingInfo = useSelector((globalState) => globalState.shippingInfo);
  const dispatch = useDispatch();

  const getOrderInfo = useCallback(async () => {
    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      IdPedido: orderId,
    };

    const resp = await ApiOrder.getOrderInfo(payload);
    if (resp.Codigo === 200) {
      setOrderInfo(resp.Respuesta[0]);
    }
  });

  const resetCart = () => {
    sessionStorage.removeItem('localIdCart');
    dispatch(startGetCart(0, []));
  };

  useEffect(async () => {
    setContent(await apiSuccess.getContent());
    getOrderInfo();
    resetCart();
  }, []);
  const successBilling = true; // true si factura está disponible
  return (
    <div className={styles.container}>
      <Header content={content} userEmail={orderInfo?.Encabezado[0].Email} />
      <Info
        successBilling={successBilling}
        orderInfoHeader={orderInfo?.Encabezado[0]}
        orderInfoDetail={orderInfo?.Detalle}
        shippingInfo={shippingInfo}
      />
      <div className={styles.summaryRows}>
        <h5>{spanish ? 'resumen' : 'summary'}</h5>
        <h5>{spanish ? 'precio unitario' : 'unit price'}</h5>
        <h5>{spanish ? 'cantidad' : 'quantity'}</h5>
        <h5>Total</h5>
      </div>
      <Summary orderDetails={orderInfo?.Detalle} />
      <Breakdown orderBreakdownInfo={orderInfo?.Encabezado[0]} />
      <GrandTotal grandTotal={orderInfo?.Encabezado[0].Total} />
      <Bottom content={content} />
    </div>
  );
};

export default Success;
